import { IDataContextProvider } from "@contexts/data/types";
import { IDataTableRequestModel } from "@type";

export const paymentsService = (dataProvider: IDataContextProvider) => ({
  loadBankPayments: async (dataTableRequest: IDataTableRequestModel) => {
    const baseUrl = dataProvider.getApiUrl();
    return await dataProvider
      .custom?.({
        method: "post",
        url: `${baseUrl}/Payments/BankPayments`,
        payload: dataTableRequest,
      })
      .then((result) => {
        return result?.data;
      });
  },

  loadReports: async (dataTableRequest: IDataTableRequestModel) => {
    const baseUrl = dataProvider.getApiUrl();
    return await dataProvider
      .custom?.({
        method: "post",
        url: `${baseUrl}/Payments/Reports`,
        payload: dataTableRequest,
      })
      .then((result) => {
        return result?.data;
      });
  },

  viewInvoiceRemittance: async (bankPaymentId: number, format: string) => {
    let resource = `Payments/BankPayments/${bankPaymentId}/ViewRemittance/${format}`;
    return dataProvider.download({ resource: resource }).then((result) => {
      return result;
    });
  },
  
  viewReportRemittance: async (year: string, month: string) => {
    var resource = `Payments/Reports/ViewReportRemittance/${year}/${month}`;
    return dataProvider.download({ resource: resource }).then((result) => {
      return result;
    });
  },
});
